import { ArrowLeft, History } from 'lucide-react'
import { Link, useLocation } from 'react-router-dom'
import { AuditLogPanel } from '@/components/entity-resolution/AuditLogPanel'
import { PageHeading, PageShell } from '@/components/layout/PageShell'
import { Button } from '@/components/ui/button'
import { useCaseContext } from '../../CaseContext'

export default function EntityResolutionAuditPage() {
  const { caseId } = useCaseContext()
  // Absolute path back to the review page (toolbar/hero renders outside this route).
  const location = useLocation()
  const backTo = location.pathname.replace(/\/audit\/?$/, '')

  return (
    <PageShell
      layout="full"
      hero={
        <div className="space-y-1">
          <div>
            <Button asChild variant="ghost" size="sm" className="-ml-2">
              <Link to={backTo}>
                <ArrowLeft className="size-3.5" />
                Back to review
              </Link>
            </Button>
          </div>
          <PageHeading
            icon={History}
            title="Merge audit log"
            summary="Every entity-resolution merge, with the full node snapshot and one-click revert."
          />
        </div>
      }
    >
      <AuditLogPanel caseId={caseId} />
    </PageShell>
  )
}
